import { useState, useEffect, useRef, useCallback } from 'react';
import { Button } from '../components/ui/button';
import { ExternalLink, Download, Loader2 } from 'lucide-react';
import api from '../lib/api';

// Prezziario in PDF: si sfoglia e si cerca come in un normale lettore PDF (Ctrl+F con il cursore sul documento).
export default function PrezziarioPdfPage() {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [height, setHeight] = useState(700);
  const boxRef = useRef(null);

  // Il visualizzatore occupa tutta l'altezza rimasta nella finestra, fino al piede di pagina.
  const fit = useCallback(() => {
    if (!boxRef.current) return;
    const top = boxRef.current.getBoundingClientRect().top;
    setHeight(Math.max(420, Math.floor(window.innerHeight - top - 90)));
  }, []);

  useEffect(() => {
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [fit, url, error]);

  useEffect(() => {
    let objectUrl = '';
    let cancelled = false;
    api.get('/price-lists/pdf', { responseType: 'blob' })
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        setUrl(objectUrl);
      })
      .catch(() => { if (!cancelled) setError('Impossibile caricare il prezziario.'); });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, []);

  const download = () => {
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Prezziario.pdf';
    a.click();
  };

  return (
    <div className="flex flex-col gap-3" data-testid="prezziario-pdf-page">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Prezziario (PDF)</h1>
          <p className="text-sm text-slate-500">Clicca sul documento e premi Ctrl+F per cercare una voce. Per una schermata più grande apri il PDF in una nuova scheda.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" disabled={!url} onClick={() => window.open(url, '_blank')} data-testid="prezziario-pdf-open">
            <ExternalLink size={16} className="mr-1" />Apri in una nuova scheda
          </Button>
          <Button variant="outline" disabled={!url} onClick={download} data-testid="prezziario-pdf-download">
            <Download size={16} className="mr-1" />Scarica
          </Button>
        </div>
      </div>
      <div ref={boxRef} style={{ height }} className="w-full">
        {error ? (
          <p className="text-sm text-red-600">{error}</p>
        ) : !url ? (
          <div className="flex items-center gap-2 text-slate-500 text-sm"><Loader2 size={16} className="animate-spin" />Caricamento del prezziario...</div>
        ) : (
          <iframe title="Prezziario" src={url} className="h-full w-full rounded-md border border-slate-200 bg-white" data-testid="prezziario-pdf-frame" />
        )}
      </div>
    </div>
  );
}
